module.exports = __webpack_public_path__ + "img/quote-logo.55484d58.png";